module.exports = __webpack_public_path__ + "static/media/topo-como-comprar-anage.36fcabbd.webp";